import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "d-block invalid-feedback"
}
const _hoisted_9 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode("Create New Field")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            class: "btn btn-primary"
          }, "Save")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("label", null, [
            _createElementVNode("strong", null, "Select Field Type")
          ], -1)),
          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldType) = $event)),
            value: "input",
            checked: _ctx.fieldType == 'input'
          }, null, 8, _hoisted_2), [
            [_vModelRadio, _ctx.fieldType]
          ]),
          _cache[12] || (_cache[12] = _createTextVNode()),
          _cache[13] || (_cache[13] = _createElementVNode("label", null, "Input Field", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fieldType) = $event)),
            value: "select"
          }, null, 512), [
            [_vModelRadio, _ctx.fieldType]
          ]),
          _cache[15] || (_cache[15] = _createTextVNode()),
          _cache[16] || (_cache[16] = _createElementVNode("label", null, "Select (Drop-down)", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fieldType) = $event)),
            value: "textbox"
          }, null, 512), [
            [_vModelRadio, _ctx.fieldType]
          ]),
          _cache[18] || (_cache[18] = _createTextVNode()),
          _cache[19] || (_cache[19] = _createElementVNode("label", null, "Textbox", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[21] || (_cache[21] = _createElementVNode("label", null, [
            _createElementVNode("strong", null, "Please Enter A Title")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass([{'is-invalid':!_ctx.validation.fieldName}, "form-control"]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fieldName) = $event)),
            required: ""
          }, null, 2), [
            [_vModelText, _ctx.fieldName]
          ]),
          (!_ctx.validation.fieldName)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "A title is required"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.fieldType == 'select')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[25] || (_cache[25] = _createElementVNode("label", null, [
                _createElementVNode("strong", null, "Drop-down Values:")
              ], -1)),
              _createVNode(_component_VueDraggableNext, {
                class: "dragArea list-group w-full",
                modelValue: _ctx.answers,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.answers) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-flex justify-content-start align-items-center mb-2",
                      key: index
                    }, [
                      _cache[23] || (_cache[23] = _createElementVNode("i", { class: "text-primary cursor-pointer fa fa-bars" }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.answers[index]) = $event),
                        class: "form-control mx-2"
                      }, null, 8, _hoisted_6), [
                        [_vModelText, _ctx.answers[index]]
                      ]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeAnswer(parseInt(index))),
                        class: "btn btn-primary float-end"
                      }, _cache[22] || (_cache[22] = [
                        _createElementVNode("i", { class: "fa fa-minus" }, null, -1)
                      ]), 8, _hoisted_7)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addAnswer && _ctx.addAnswer(...args))),
                class: "btn btn-primary float-end"
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("i", { class: "fa fa-plus" }, null, -1)
              ])),
              (!_ctx.validation.answers)
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.validation.answersText), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}